<div ngbAccordion #OuterAccordion="ngbAccordion" class="custom-collapse px-1">
  @for (group of groups; track trackByProductCode($index, group)) {
    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>
          <span class="lead collapse-title group-header-container f-gap-small">
            <div
              class="custom-control custom-checkbox not-fixed-width"
              (click)="$event.stopPropagation()"
            >
              <input
                type="checkbox"
                class="custom-control-input"
                [id]="componentId + '-grp-style-' + group.productCode"
                [checked]="areAllGroupItemsSelected(group.itemIndexes)"
                (change)="onToggleGroupSelectAll(group.itemIndexes, $event)"
              />
              <label
                class="custom-control-label"
                [for]="componentId + '-grp-style-' + group.productCode"
              ></label>
            </div>
            <div class="not-fixed-width image-container">
              <img imageSize [src]="group.img" alt="" />
            </div>
            <div class="truncate flex-1">
              <div class="bold-text">{{ "MENU.STYLE_CODE" | translate }}</div>
              <div class="margin-top-small">{{ group.productCode }}</div>
              <div
                class="margin-top-small truncate"
                [title]="group.productTitle"
              >
                {{ group.productTitle }}
              </div>
            </div>
            <div class="truncate flex-1">
              <div class="bold-text">{{ "MENU.BY_DATE" | translate }}</div>
              <div class="margin-top-small">
                {{ group.minRequestedDeliveryDate | date: "d MMM y" }}
              </div>
            </div>
            <div class="truncate flex-1">
              <div class="bold-text">{{ "MENU.CUSTOM_DATE" | translate }}</div>
              @if (!group.minCustomDate) {
                <div class="margin-top-small">-</div>
              }
              @if (
                group.minCustomDate &&
                isSingleDate(group.minCustomDate, group.maxCustomDate)
              ) {
                <div class="margin-top-small">
                  {{ group.minCustomDate | date: "d MMM y" }}
                </div>
              }
              @if (
                group.minCustomDate &&
                !isSingleDate(group.minCustomDate, group.maxCustomDate)
              ) {
                <div class="margin-top-small">
                  {{ group.minCustomDate | date: "d MMM y" }} -
                  {{ group.maxCustomDate | date: "d MMM y" }}
                </div>
              }
            </div>
            <div class="truncate flex-1">
              <div class="bold-text">
                {{ "CUSTOM_SHIP_DATES.N_ORDER_ITEMS" | translate }}
              </div>
              <div class="margin-top-small">{{ group.itemIndexes.length }}</div>
            </div>
          </span>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <app-items-table
              [itemIndexes]="group.itemIndexes"
              [orderItemsFormCustomDate]="orderItemsFormCustomDate"
              [supportsSplitDelivery]="supportsSplitDelivery"
              [showStockQty]="showStockQty"
              [maxStoreCustomDate]="maxStoreCustomDate"
              [componentId]="componentId"
              [idPrefix]="'-style-'"
              itemDisplayMode="color-size"
              (dateAdded)="dateAdded.emit($event)"
              (stockDateAdded)="stockDateAdded.emit($event)"
              (customDateCleared)="customDateCleared.emit($event)"
              (dateRemoved)="dateRemoved.emit($event)"
              (dateTimeChanged)="dateTimeChanged.emit($event)"
            >
            </app-items-table>
          </ng-template>
        </div>
      </div>
    </div>
  }
</div>
